import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB1pyoQDha1vYSIAPsrTPtzfad14TPJ9qA",
  authDomain: "pickleball-app-c5b88.firebaseapp.com",
  projectId: "pickleball-app-c5b88",
  storageBucket: "pickleball-app-c5b88.firebasestorage.app",
  messagingSenderId: "440041710255",
  appId: "1:440041710255:web:1a8a30be6142f4fd75aa5a",
  measurementId: "G-3DR6SDDKN1",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// Must match the region the Cloud Functions are deployed to (see functions/index.js).
export const functions = getFunctions(app, "europe-west2");

// Analytics only works in a real browser (not SSR/tests), so guard it.
export let analytics = null;
analyticsIsSupported().then(function (supported) {
  if (supported) analytics = getAnalytics(app);
});
